export default "__VITE_ASSET__Bjw2dInc__"